/* eslint-disable no-multi-assign */
window.$ = window.jQuery = require('jquery');
